import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['actual', 'comprehensive']

  declare readonly actualTarget: HTMLInputElement
  declare readonly comprehensiveTarget: HTMLInputElement

  connect (): void {
    this.toggle()
  }

  toggle (): void {
    const actualFilled = this.actualTarget.value.trim() !== ''
    this.comprehensiveTarget.disabled = !actualFilled
  }
}
